import { render, staticRenderFns } from "./EditPtMappingDialog.vue?vue&type=template&id=2ee93016&"
import script from "./EditPtMappingDialog.vue?vue&type=script&lang=js&"
export * from "./EditPtMappingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports